import styled from 'styled-components';
import { typeStyle } from '../../styles/config/typeStyles';
import media from '../../styles/config/mediaQueries';

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & > svg {
    width: 15px;
  }
  ${media.mobile`
    margin: 0 0
      ${props => (props.styling === 'h1' ? '5px' : props.styling === 'h2' ? '10px' : '22px')};
  `}
  ${media.desktop`
    margin: 0 0
      ${props => (props.styling === 'h1' ? '5px' : props.styling === 'h2' ? '10px' : '13px')};
  `}
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;

  svg {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
`;

export const StyledHeading = styled.h2`
  ${props => typeStyle[props.styling]};
`;
